import { Task } from "../types";

type UnknownRecord = Record<string, unknown>;

function isRecord(value: unknown): value is UnknownRecord {
  return typeof value === "object" && value !== null;
}

function asTaskArray(value: unknown): Task[] | null {
  return Array.isArray(value) ? (value as Task[]) : null;
}

/**
 * Normalize task list responses across legacy and wrapped API shapes.
 */
export function extractTasksArray(response: unknown): Task[] {
  const directArray = asTaskArray(response);
  if (directArray) return directArray;

  if (!isRecord(response)) return [];

  const responseTasks = asTaskArray(response.tasks);
  if (responseTasks) return responseTasks;

  if (isRecord(response.data)) {
    const dataTasks = asTaskArray(response.data.tasks);
    if (dataTasks) return dataTasks;
  }

  if (isRecord(response.tasks)) {
    const nestedTasks = asTaskArray(response.tasks.tasks);
    if (nestedTasks) return nestedTasks;
  }

  if (isRecord(response.data) && isRecord(response.data.tasks)) {
    const nestedDataTasks = asTaskArray(response.data.tasks.tasks);
    if (nestedDataTasks) return nestedDataTasks;
  }

  return [];
}
